module.exports = __webpack_public_path__ + "testreggie.png?f901c3d8afc3dea057e0a4060144757c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testreggie.png
// module id = 112
// module chunks = 0